/**
 * Mürettebat bordrosu ekranı (M16; ADR 0061): ortağın "Crew Payroll — Payment Register &
 * Reconciliation" ekranının dili. İngilizce varsayılan, Türkçe ikinci dil. Kalemlerin adı ve sırası
 * ortağın diliyle; Türkçede de modül adı "Payroll" (M16b, ADR 0066).
 */
export const payrollEn = {
  title: 'Crew Payroll',
  showing: 'Showing {{from}} - {{to}} of {{total}} records',
  sections: {
    monthly: 'Monthly Payroll',
    advances: 'Advances & Deductions',
    allotments: 'Allotment',
    payslips: 'Payslip Generator',
    payments: 'Payment Register & Reconciliation',
    closing: 'Monthly Closing',
    reports: 'Payroll Reports',
  },
  descriptions: {
    monthly:
      'Monthly account per crew member: wages and extras (overtime, bonus, allowances…, several per month); home allotment, cash advance, slopchest and any other deduction are deducted to give the balance.',
    advances:
      'Cash advances, slopchest purchases and other deductions (internet, phone, company types) on board, deducted from the month’s wages.',
    allotments:
      'Regular payments to a family member or another person, as a fixed amount or a percentage of the basic wage (MLC 2006 Standard A2.2).',
    payslips: 'Monthly statement of wages for each crew member (MLC 2006 Standard A2.2).',
    payments:
      'Payments for the period by bank transfer or cash on board, with receipts and reconciliation. Entered by the office; read-only on board.',
    closing:
      'Checks and closes the period; a closed period cannot be changed and is reopened only with a reason.',
    reports:
      'Net payment list of the period, from wages to balance, as PDF or CSV with totals per currency.',
  },
  breadcrumb: { home: 'Home', crew: 'Crew', payroll: 'Payroll' },
  filters: {
    vessel: 'Vessel',
    period: 'Payroll Period',
    status: 'Period status',
    paymentStatus: 'Payment Status',
    paymentType: 'Payment Type',
    rank: 'Rank',
    all: 'All',
    search: 'Search crew, reference…',
    reset: 'Reset',
  },
  periodStatus: { open: 'Open', closed: 'Closed', none: 'Not opened' },
  recordedOn: { office: 'Office', vessel: 'On board' },
  cards: {
    payable: 'Total Payable ({{currency}})',
    recorded: 'Recorded Payments ({{currency}})',
    outstanding: 'Outstanding ({{currency}})',
    progress: 'Payment Progress',
    others: 'Other currencies: {{list}}',
    empty: 'No amounts yet',
  },
  actions: {
    openPeriod: 'Open {{month}} payroll',
    addCrew: 'Add Crew',
    newEntry: 'New Entry',
    newAllotment: 'New Allotment',
    newPayment: 'New Payment',
    exportCsv: 'Export CSV',
    exportPdf: 'Net Payment List (PDF)',
    payslip: 'Payslip',
    allPayslips: 'All Payslips (PDF)',
    edit: 'Edit',
    view: 'View',
    remove: 'Remove',
    reconcile: 'Mark Reconciled',
    close: 'Close Period',
    reopen: 'Reopen Period',
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    retry: 'Retry',
    upload: 'Attach receipt',
    useSuggested: 'Use {{days}} days from Crew List',
    computeOvertime: 'Hours × rate',
    computeAmount: 'Qty × rate',
    addExtra: 'Add Extra',
    addExtraFor: 'Add extra for {{name}}',
    extraTypes: 'Extra Types',
    deductionTypes: 'Deduction Types',
    deactivate: 'Deactivate',
    activate: 'Activate',
    addType: 'Add type',
    rename: 'Rename',
    closeWindow: 'Close',
  },
  columns: {
    no: '#',
    name: 'Name',
    rank: 'Rank',
    days: 'Days',
    currency: 'Cur.',
    wage: 'Monthly Wage',
    // Ortağın kalem sırası (M16b, ADR 0066): Wages → Extra → Home Allotment → Cash Advance →
    // Slopchest → Other Deductions → Balance
    wages: 'Wages',
    extra: 'Extra',
    allotment: 'Home Allotment',
    advances: 'Cash Advance',
    slopchest: 'Slopchest',
    otherDeductions: 'Other Deductions',
    balance: 'Balance',
    earnings: 'Earnings',
    deductions: 'Deductions',
    payable: 'Total Payable',
    date: 'Date',
    kind: 'Type',
    amount: 'Amount',
    description: 'Description',
    beneficiary: 'Beneficiary',
    relationship: 'Relationship',
    basis: 'Basis',
    valid: 'Valid',
    type: 'Type',
    method: 'Method',
    reference: 'Reference',
    status: 'Status',
    actions: 'Actions',
  },
  // Kesinti türleri (ADR 0080 §2): avans ve slopchest kendi kaleminde; diğerleri Other Deductions
  kinds: {
    advance: 'Cash Advance',
    slopchest: 'Slopchest',
    internet: 'Internet / Wi-Fi data',
    phone: 'Phone / calling card',
    union_dues: 'Union dues / welfare fund',
    personal_expenses: 'Personal expenses paid by the ship',
    lost_equipment: 'Lost or damaged company property',
    other: 'Other deduction',
    company: 'Company type',
  },
  kindGroups: {
    entries: 'Advance and slopchest',
    common: 'Deductions',
    company: 'Company deductions',
  },
  // Extra türleri (ADR 0068 §2): ITF/IBF toplu sözleşme kalemleri ve bordro yazılımı emsalleri
  extraTypes: {
    fixed_overtime: 'Fixed overtime',
    extra_overtime: 'Extra overtime',
    leave_pay: 'Leave pay',
    subsistence: 'Subsistence allowance',
    bonus: 'Bonus',
    hazardous_cargo: 'Tanker / hazardous cargo allowance',
    high_risk_area: 'High-risk area bonus',
    hold_cleaning: 'Hold cleaning',
    lashing: 'Lashing / unlashing',
    additional_duty: 'Additional duty (e.g. cook, medical care)',
    night_work: 'Night work',
    port_allowance: 'Port / shore leave allowance',
    travel_allowance: 'Travel allowance',
    reimbursement: 'Reimbursement',
    other: 'Other',
    company: 'Company type',
  },
  extraGroups: { common: 'Common types', company: 'Company types' },
  bases: { fixed: 'Fixed amount', percent: '% of basic wage' },
  paymentTypes: { salary: 'Salary', allotment: 'Allotment', final_settlement: 'Final Settl.' },
  methods: { bank_transfer: 'Bank Transfer', cash_on_board: 'Cash On Board' },
  paymentStatus: { recorded: 'Recorded', reconciled: 'Reconciled' },
  active: { yes: 'Active this month', no: 'Not active this month' },
  tabs: { register: 'Payment Register', reconciliation: 'Reconciliation' },
  form: {
    lineTitle: 'Payroll Line',
    entryTitle: 'Advance / Deduction',
    allotmentTitle: 'Allotment',
    paymentTitle: 'Payment Detail',
    extraTitle: 'Extra',
    extraType: 'Extra type',
    quantity: 'Quantity (hours, holds, days)',
    rate: 'Unit rate',
    amountHint: 'If quantity and rate are entered, the amount must be quantity × rate.',
    extras: 'Extras',
    noExtras: 'No extras this month.',
    legacyExtra: 'Entered before itemised extras; moved to an extra item when the line is saved.',
    extraTotal: 'Extra total',
    deductions: 'Other deductions',
    legacyDeduction: 'Entered on the payroll line before itemised deductions.',
    deductionHint:
      'Deduct only what national law or the collective agreement allows (MLC 2006, B2.2.2).',
    crewMember: 'Crew Member',
    chooseCrew: 'Choose a crew member',
    currency: 'Currency',
    days: 'Days on board',
    daysHint: '{{days}} days in month',
    monthlyWage: 'Monthly wage',
    basicEarned: 'Basic wage for the days',
    overtimeHours: 'Overtime hours',
    overtimeRate: 'Hourly rate',
    overtimeAmount: 'Overtime amount',
    overtimeHint: 'If hours and rate are entered, the amount must be hours × rate.',
    otherEarnings: 'Other earnings',
    otherEarningsNote: 'Other earnings description',
    otherDeductions: 'Other deductions',
    otherDeductionsNote: 'Other deductions description',
    remarks: 'Remarks',
    kind: 'Type',
    day: 'Date',
    amount: 'Amount',
    description: 'Description',
    beneficiary: 'Beneficiary',
    relationship: 'Relationship',
    bankDetails: 'Bank details (bank, IBAN / account)',
    basis: 'Basis',
    percent: 'Percentage of basic wage',
    startMonth: 'From month',
    endMonth: 'Until month (optional)',
    paymentType: 'Payment Type',
    allotment: 'Allotment',
    paymentDay: 'Payment Date',
    method: 'Payment Method',
    reference: 'Reference No.',
    referenceHint: 'Required for bank transfer.',
    bankAccount: 'Bank Account',
    status: 'Status',
    attachments: 'Attachments',
    noAttachments: 'No receipt attached.',
    attachmentTypes: 'JPG, PNG or PDF, up to 25 MB.',
    reconciledNote: 'Reconciled payments cannot be changed.',
    readOnly: 'Read-only: the monthly account is entered on board.',
    paymentsOffice:
      'Payments, receipts and reconciliation are entered by the office; on board they are read-only.',
    recordedBy: 'Recorded by',
    closedNote: 'The period is closed; lines and entries cannot be changed.',
    net: 'Balance',
    summary: 'Calculation',
  },
  dialogs: {
    removeTitle: 'Remove record',
    removeText: 'The record is kept in the history with your reason.',
    reason: 'Reason',
    reasonHint: '5–500 characters',
    reopenReasonHint: '5–2000 characters',
    password: 'Your password',
    closeTitle: 'Close {{month}} payroll',
    closeText:
      'The full calculation is stored with a hash; lines and entries become read-only. The office can still record payments.',
    reopenTitle: 'Reopen {{month}} payroll',
    reopenText:
      'Reopening is recorded with your reason; close the period again after the correction.',
    reconcileTitle: 'Mark payment reconciled',
    reconcileText: 'After reconciliation the payment cannot be changed or removed.',
    confirm: 'Confirm',
    extraTypesTitle: 'Extra Types',
    extraTypesText:
      'Common types are built in. Add the company’s own types here; they are sent to all vessels. Removed types stay on earlier records.',
    typeName: 'Type name',
    builtIn: 'Built-in types',
    companyTypes: 'Company types',
    noCompanyTypes: 'No company types yet.',
    deductionTypesTitle: 'Deduction Types',
    deductionTypesText:
      'Common deduction types are built in. Add the company’s own types here; they are sent to all vessels. Types are not deleted: a deactivated type is not offered for new entries and stays on earlier records. Deduct only what national law or the collective agreement allows (MLC 2006, Guideline B2.2.2).',
    typeNameEn: 'Name (English)',
    typeNameTr: 'Name (Turkish, optional)',
    inactive: 'Inactive',
  },
  closing: {
    checks: 'Closing checks',
    ready: 'Ready to close: all checks passed.',
    closedReady: 'Closed {{at}} by {{by}}.',
    issues: {
      NO_LINES: 'No crew lines in the period.',
      NEGATIVE_NET: '{{name}}: balance is negative.',
      CURRENCY_MISMATCH:
        '{{name}}: an extra, deduction, cash advance, slopchest or home allotment is in a different currency.',
      ENTRY_WITHOUT_LINE: '{{name}}: has entries but no payroll line.',
    },
    totals: 'Totals by currency',
    people: 'Crew',
    history: 'Closing History',
    noHistory: 'The period has not been closed yet.',
    events: { closed: 'Closed', reopened: 'Reopened' },
    hash: 'Hash',
    by: 'By',
    at: 'Time',
    reason: 'Reason',
  },
  empty: {
    noAccess: 'You do not have permission to view payroll.',
    noPeriodShip: 'The payroll for {{month}} has not been opened yet.',
    noPeriodWeb: 'No payroll for {{month}} has been received from the vessel yet.',
    noLines: 'No crew lines yet.',
    noLinesShip: 'Use “Add Crew” to add crew members from the Crew List.',
    noEntries: 'No advances, slopchest entries or deductions in this period.',
    noAllotments: 'No allotments defined.',
    noPayments: 'No payments recorded for this period.',
    noMatch: 'No records match the filters.',
    clear: 'Clear filters',
  },
  errors: {
    load: 'Payroll could not be loaded.',
    save: 'Could not save ({{code}}).',
    pdf: 'The PDF could not be created.',
    codes: {
      FORBIDDEN: 'You do not have permission for this action.',
      PERIOD_CLOSED: 'The period is closed.',
      PERIOD_EXISTS: 'This period is already open.',
      FUTURE_PERIOD: 'A future month cannot be opened.',
      DUPLICATE_LINE: 'This crew member already has a line.',
      CREW_NOT_ON_VESSEL: 'The person is not on the vessel in this month (Crew List).',
      CURRENCY_MISMATCH: 'The currency must match the crew member’s payroll line.',
      ENTRY_OUTSIDE_PERIOD: 'The date must be within the period month.',
      FUTURE_DATE: 'The date cannot be in the future.',
      PAYMENT_RECONCILED: 'Reconciled payments cannot be changed.',
      REASON_REQUIRED: 'Enter a reason.',
      INVALID_CREDENTIALS: 'Wrong password.',
      NEGATIVE_NET: 'A crew member’s balance is negative.',
      NO_LINES: 'No crew lines in the period.',
      ENTRY_WITHOUT_LINE: 'A person has entries but no payroll line.',
      ROW_VERSION_CONFLICT: 'The record was changed by someone else; reload and try again.',
      VALIDATION_FAILED: 'Check the fields.',
      OFFICE_IS_WRITER: 'Payments are entered by the office.',
      PAYMENT_VOIDED: 'The payment has been removed.',
      FILE_TYPE_MISMATCH: 'Attach a JPG, PNG or PDF file.',
      FILE_TOO_LARGE: 'The file is larger than 25 MB.',
      NO_PAYROLL_LINE: 'Add the crew member’s payroll line first.',
      UNKNOWN_EXTRA_TYPE: 'The extra type has been removed; choose another type.',
      DUPLICATE_EXTRA_TYPE: 'A type with this name already exists.',
      INVALID_EXTRA_TYPE: 'Enter a type name (up to 100 characters).',
      INVALID_PAYROLL_EXTRA: 'Check the extra: type, amount and, for “Other”, a description.',
      INVALID_PAYROLL_ENTRY:
        'Check the entry: type, date, amount and, for “Other deduction” or lost property, a description.',
      UNKNOWN_DEDUCTION_TYPE:
        'The deduction type is not known on this vessel; choose another type.',
      DEDUCTION_TYPE_INACTIVE: 'The deduction type has been deactivated; choose another type.',
      DUPLICATE_DEDUCTION_TYPE: 'A deduction type with this name already exists.',
      INVALID_DEDUCTION_TYPE: 'Enter a type name (up to 100 characters).',
    },
  },
  notices: {
    saved: 'Saved.',
    removed: 'Removed.',
    reconciled: 'Payment reconciled.',
    closed: 'Period closed.',
    reopened: 'Period reopened.',
    opened: 'Period opened.',
    uploaded: '{{name}} attached.',
  },
  pdf: {
    payslip: 'Payslip',
    netList: 'Net Payment List',
    vessel: 'Vessel',
    period: 'Period',
    crew: 'Crew member',
    rank: 'Rank',
    currency: 'Currency',
    days: 'Days on board',
    earnings: 'Earnings',
    deductions: 'Deductions',
    wages: 'Wages ({{days}} days of {{wage}})',
    extra: 'Extra',
    extraOvertime: 'Extra — overtime',
    extraOvertimeHours: 'Extra — overtime ({{hours}} h × {{rate}})',
    extraOther: 'Extra — {{note}}',
    extraItem: 'Extra — {{label}}',
    homeAllotment: 'Home Allotment — {{name}}',
    cashAdvance: 'Cash Advance',
    slopchest: 'Slopchest',
    otherDeductions: 'Other Deductions',
    deductionItem: '{{label}} {{day}}',
    noDeductions: 'No deductions',
    totalEarnings: 'Total earnings',
    totalDeductions: 'Total deductions',
    balance: 'Balance',
    payments: 'Payments',
    noPayments: 'No payments recorded yet.',
    date: 'Date',
    type: 'Type',
    method: 'Method',
    reference: 'Reference',
    amount: 'Amount',
    statementNote:
      'Monthly account of wages due and paid (MLC 2006 Standard A2.2, paragraph 2). Amounts are in the crew member’s contract currency; no exchange rate was applied.',
    seafarerSign: 'Seafarer signature',
    masterSign: 'Master signature',
    closed: 'Period closed {{at}} · hash {{hash}}',
    open: 'Period open — draft',
    printed: 'Printed {{at}}',
    page: 'Page {{page}} of {{pages}}',
    total: 'Total',
    people: '{{count}} crew',
    netListNote:
      'Balance = wages + extra − home allotment − cash advance − slopchest − other deductions. Total payable = balance + home allotment. Totals per currency, without exchange.',
  },
  csv: {
    name: 'Name',
    rank: 'Rank',
    currency: 'Currency',
    wages: 'Wages',
    extra: 'Extra',
    homeAllotment: 'Home Allotment',
    cashAdvance: 'Cash Advance',
    slopchest: 'Slopchest',
    otherDeductions: 'Other Deductions',
    balance: 'Balance',
    payable: 'Total Payable',
    total: 'Total',
  },
};

export const payrollTr: typeof payrollEn = {
  // Modül adı Türkçede de "Payroll" (ortaklar "Bordro"yu yadırgadı; M16b, ADR 0066)
  title: 'Payroll',
  showing: '{{total}} kayıttan {{from}} - {{to}} gösteriliyor',
  sections: {
    monthly: 'Aylık Hesap',
    advances: 'Avans ve Kesintiler',
    allotments: 'Allotment',
    payslips: 'Ücret Pusulası',
    payments: 'Ödeme Defteri ve Mutabakat',
    closing: 'Ay Kapanışı',
    reports: 'Payroll Raporları',
  },
  descriptions: {
    monthly:
      'Kişi başı aylık hesap: maaş ve ekstralar (fazla mesai, prim, harcırah…, ayda birden çok); Home Allotment, gemide avans, slopchest ve varsa diğer kesinti düşülerek kalan bulunur.',
    advances:
      'Gemide verilen nakit avanslar, slopchest alımları ve diğer kesintiler (internet, telefon, şirket türleri); ayın ücretinden düşülür.',
    allotments:
      'Aileye ya da başka bir kişiye düzenli ödeme: sabit tutar ya da temel ücretin yüzdesi (MLC 2006 Standart A2.2).',
    payslips: 'Her gemiadamı için aylık ücret hesap dökümü (MLC 2006 Standart A2.2).',
    payments:
      'Dönem için banka havalesi ya da gemide nakit yapılan ödemeler, dekontları ve mutabakatı. Ofis girer; gemide salt okunur.',
    closing:
      'Dönemi denetler ve kapatır; kapanan dönem değişmez, yalnız gerekçeyle yeniden açılır.',
    reports:
      'Dönemin net ödeme listesi, maaştan kalana, PDF ya da CSV olarak, para birimine göre toplamlarla.',
  },
  breadcrumb: { home: 'Ana Sayfa', crew: 'Personel', payroll: 'Payroll' },
  filters: {
    vessel: 'Gemi',
    period: 'Dönem',
    status: 'Dönem durumu',
    paymentStatus: 'Ödeme Durumu',
    paymentType: 'Ödeme Türü',
    rank: 'Rütbe',
    all: 'Tümü',
    search: 'Kişi, referans ara…',
    reset: 'Sıfırla',
  },
  periodStatus: { open: 'Açık', closed: 'Kapalı', none: 'Açılmadı' },
  recordedOn: { office: 'Ofis', vessel: 'Gemide' },
  cards: {
    payable: 'Toplam Ödenecek ({{currency}})',
    recorded: 'Kaydedilen Ödemeler ({{currency}})',
    outstanding: 'Ödenmemiş ({{currency}})',
    progress: 'Ödeme İlerlemesi',
    others: 'Diğer para birimleri: {{list}}',
    empty: 'Henüz tutar yok',
  },
  actions: {
    openPeriod: '{{month}} dönemini aç',
    addCrew: 'Personel Ekle',
    newEntry: 'Yeni Giriş',
    newAllotment: 'Yeni Allotment',
    newPayment: 'Yeni Ödeme',
    exportCsv: 'CSV Dışa Aktar',
    exportPdf: 'Net Ödeme Listesi (PDF)',
    payslip: 'Pusula',
    allPayslips: 'Tüm Pusulalar (PDF)',
    edit: 'Düzenle',
    view: 'Görüntüle',
    remove: 'Kaldır',
    reconcile: 'Mutabık İşaretle',
    close: 'Dönemi Kapat',
    reopen: 'Dönemi Yeniden Aç',
    save: 'Kaydet',
    update: 'Güncelle',
    cancel: 'Vazgeç',
    retry: 'Yeniden dene',
    upload: 'Dekont ekle',
    useSuggested: 'Crew List’ten {{days}} gün',
    computeOvertime: 'Saat × oran',
    computeAmount: 'Miktar × ücret',
    addExtra: 'Ekstra Ekle',
    addExtraFor: '{{name}} için ekstra ekle',
    extraTypes: 'Ekstra Türleri',
    deductionTypes: 'Kesinti Türleri',
    deactivate: 'Pasifleştir',
    activate: 'Etkinleştir',
    addType: 'Tür ekle',
    rename: 'Yeniden adlandır',
    closeWindow: 'Kapat',
  },
  columns: {
    no: '#',
    name: 'Ad',
    rank: 'Rütbe',
    days: 'Gün',
    currency: 'PB',
    wage: 'Aylık Ücret',
    wages: 'Maaş',
    extra: 'Ekstra',
    allotment: 'Home Allotment',
    advances: 'Gemide Avans',
    slopchest: 'Slopchest',
    otherDeductions: 'Diğer Kesinti',
    balance: 'Kalan',
    earnings: 'Kazanç',
    deductions: 'Kesinti',
    payable: 'Toplam Ödenecek',
    date: 'Tarih',
    kind: 'Tür',
    amount: 'Tutar',
    description: 'Açıklama',
    beneficiary: 'Alıcı',
    relationship: 'Yakınlık',
    basis: 'Esas',
    valid: 'Geçerlilik',
    type: 'Tür',
    method: 'Yöntem',
    reference: 'Referans',
    status: 'Durum',
    actions: 'İşlemler',
  },
  kinds: {
    advance: 'Gemide Avans',
    slopchest: 'Slopchest',
    internet: 'İnternet / Wi-Fi veri paketi',
    phone: 'Telefon / arama kartı',
    union_dues: 'Sendika aidatı / yardım fonu',
    personal_expenses: 'Geminin ödediği kişisel masraf',
    lost_equipment: 'Kayıp ya da hasarlı şirket malı',
    other: 'Diğer kesinti',
    company: 'Şirket türü',
  },
  kindGroups: {
    entries: 'Avans ve slopchest',
    common: 'Kesintiler',
    company: 'Şirket kesintileri',
  },
  extraTypes: {
    fixed_overtime: 'Sabit fazla mesai',
    extra_overtime: 'Ek fazla mesai',
    leave_pay: 'İzin ücreti',
    subsistence: 'İaşe harcırahı',
    bonus: 'Prim',
    hazardous_cargo: 'Tanker / tehlikeli yük primi',
    high_risk_area: 'Riskli bölge primi',
    hold_cleaning: 'Ambar temizliği',
    lashing: 'Lashing / unlashing',
    additional_duty: 'Ek görev (ör. aşçılık, sağlık bakımı)',
    night_work: 'Gece çalışması',
    port_allowance: 'Liman / karaya çıkış harçlığı',
    travel_allowance: 'Yol harcırahı',
    reimbursement: 'Masraf iadesi',
    other: 'Diğer',
    company: 'Şirket türü',
  },
  extraGroups: { common: 'Hazır türler', company: 'Şirket türleri' },
  bases: { fixed: 'Sabit tutar', percent: 'Temel ücretin %’si' },
  paymentTypes: { salary: 'Maaş', allotment: 'Allotment', final_settlement: 'Hesap Kapama' },
  methods: { bank_transfer: 'Banka Havalesi', cash_on_board: 'Gemide Nakit' },
  paymentStatus: { recorded: 'Kaydedildi', reconciled: 'Mutabık' },
  active: { yes: 'Bu ay geçerli', no: 'Bu ay geçerli değil' },
  tabs: { register: 'Ödeme Defteri', reconciliation: 'Mutabakat' },
  form: {
    lineTitle: 'Hesap Satırı',
    entryTitle: 'Avans / Kesinti',
    allotmentTitle: 'Allotment',
    paymentTitle: 'Ödeme Ayrıntısı',
    extraTitle: 'Ekstra',
    extraType: 'Ekstra türü',
    quantity: 'Miktar (saat, ambar, gün)',
    rate: 'Birim ücret',
    amountHint: 'Miktar ve birim ücret girilirse tutar miktar × ücret olmalıdır.',
    extras: 'Ekstralar',
    noExtras: 'Bu ay ekstra yok.',
    legacyExtra: 'Kalemli ekstradan önce girildi; satır kaydedilince ekstra kalemine taşınır.',
    deductions: 'Diğer kesintiler',
    legacyDeduction: 'Kalemli kesintiden önce hesap satırına girildi.',
    deductionHint:
      'Yalnız ulusal mevzuatın ya da toplu sözleşmenin izin verdiği kesintiyi yapın (MLC 2006, B2.2.2).',
    extraTotal: 'Ekstra toplamı',
    crewMember: 'Personel',
    chooseCrew: 'Personel seçin',
    currency: 'Para birimi',
    days: 'Gemide gün',
    daysHint: 'Ay {{days}} gün',
    monthlyWage: 'Aylık ücret',
    basicEarned: 'Günlere düşen temel ücret',
    overtimeHours: 'Fazla mesai saati',
    overtimeRate: 'Saatlik oran',
    overtimeAmount: 'Fazla mesai tutarı',
    overtimeHint: 'Saat ve oran girilirse tutar saat × oran olmalıdır.',
    otherEarnings: 'Diğer kazanç',
    otherEarningsNote: 'Diğer kazanç açıklaması',
    otherDeductions: 'Diğer kesinti',
    otherDeductionsNote: 'Diğer kesinti açıklaması',
    remarks: 'Not',
    kind: 'Tür',
    day: 'Tarih',
    amount: 'Tutar',
    description: 'Açıklama',
    beneficiary: 'Alıcı',
    relationship: 'Yakınlık',
    bankDetails: 'Banka bilgisi (banka, IBAN / hesap)',
    basis: 'Esas',
    percent: 'Temel ücretin yüzdesi',
    startMonth: 'Başlangıç ayı',
    endMonth: 'Bitiş ayı (isteğe bağlı)',
    paymentType: 'Ödeme Türü',
    allotment: 'Allotment',
    paymentDay: 'Ödeme Tarihi',
    method: 'Ödeme Yöntemi',
    reference: 'Referans No.',
    referenceHint: 'Banka havalesinde zorunlu.',
    bankAccount: 'Banka Hesabı',
    status: 'Durum',
    attachments: 'Ekler',
    noAttachments: 'Dekont eklenmedi.',
    attachmentTypes: 'JPG, PNG ya da PDF, en çok 25 MB.',
    reconciledNote: 'Mutabık ödeme değiştirilemez.',
    readOnly: 'Salt okunur: aylık hesap gemide girilir.',
    paymentsOffice: 'Ödemeyi, dekontu ve mutabakatı ofis girer; gemide salt okunurdur.',
    recordedBy: 'Kaydeden',
    closedNote: 'Dönem kapalı; satırlar ve girişler değiştirilemez.',
    net: 'Kalan',
    summary: 'Hesap',
  },
  dialogs: {
    removeTitle: 'Kaydı kaldır',
    removeText: 'Kayıt gerekçenizle birlikte geçmişte kalır.',
    reason: 'Gerekçe',
    reasonHint: '5–500 karakter',
    reopenReasonHint: '5–2000 karakter',
    password: 'Parolanız',
    closeTitle: '{{month}} dönemini kapat',
    closeText:
      'Hesabın tamamı hash ile saklanır; satırlar ve girişler salt okunur olur. Ofis ödeme girmeyi sürdürür.',
    reopenTitle: '{{month}} dönemini yeniden aç',
    reopenText: 'Yeniden açma gerekçenizle kaydedilir; düzeltmeden sonra dönemi yeniden kapatın.',
    reconcileTitle: 'Ödemeyi mutabık işaretle',
    reconcileText: 'Mutabakattan sonra ödeme değiştirilemez ve kaldırılamaz.',
    confirm: 'Onayla',
    extraTypesTitle: 'Ekstra Türleri',
    extraTypesText:
      'Hazır türler yerleşiktir. Şirketin kendi türlerini buradan ekleyin; bütün gemilere gider. Kaldırılan tür eski kayıtlarda kalır.',
    typeName: 'Tür adı',
    builtIn: 'Hazır türler',
    companyTypes: 'Şirket türleri',
    noCompanyTypes: 'Henüz şirket türü yok.',
    deductionTypesTitle: 'Kesinti Türleri',
    deductionTypesText:
      'Hazır kesinti türleri yerleşiktir. Şirketin kendi türlerini buradan ekleyin; bütün gemilere gider. Tür silinmez: pasifleştirilen tür yeni girişte seçilmez, eski kayıtlarda kalır. Yalnız ulusal mevzuatın ya da toplu sözleşmenin izin verdiği kesintiyi yapın (MLC 2006, B2.2.2).',
    typeNameEn: 'Ad (İngilizce)',
    typeNameTr: 'Ad (Türkçe, isteğe bağlı)',
    inactive: 'Pasif',
  },
  closing: {
    checks: 'Kapanış denetimleri',
    ready: 'Kapanmaya hazır: bütün denetimler geçti.',
    closedReady: '{{at}} tarihinde {{by}} kapattı.',
    issues: {
      NO_LINES: 'Dönemde personel satırı yok.',
      NEGATIVE_NET: '{{name}}: kalan eksi.',
      CURRENCY_MISMATCH:
        '{{name}}: ekstra, kesinti, gemide avans, slopchest ya da Home Allotment başka para biriminde.',
      ENTRY_WITHOUT_LINE: '{{name}}: girişleri var ama hesap satırı yok.',
    },
    totals: 'Para birimine göre toplamlar',
    people: 'Personel',
    history: 'Kapanış Geçmişi',
    noHistory: 'Dönem henüz kapatılmadı.',
    events: { closed: 'Kapatıldı', reopened: 'Yeniden açıldı' },
    hash: 'Hash',
    by: 'Kişi',
    at: 'Zaman',
    reason: 'Gerekçe',
  },
  empty: {
    noAccess: 'Payroll’u görme yetkiniz yok.',
    noPeriodShip: '{{month}} dönemi henüz açılmadı.',
    noPeriodWeb: '{{month}} dönemi gemiden henüz gelmedi.',
    noLines: 'Henüz personel satırı yok.',
    noLinesShip: 'Crew List’ten personel eklemek için “Personel Ekle”yi kullanın.',
    noEntries: 'Bu dönemde avans, slopchest ya da kesinti girişi yok.',
    noAllotments: 'Tanımlı allotment yok.',
    noPayments: 'Bu dönem için kayıtlı ödeme yok.',
    noMatch: 'Süzgeçlere uyan kayıt yok.',
    clear: 'Süzgeçleri temizle',
  },
  errors: {
    load: 'Payroll yüklenemedi.',
    save: 'Kaydedilemedi ({{code}}).',
    pdf: 'PDF oluşturulamadı.',
    codes: {
      FORBIDDEN: 'Bu işlem için yetkiniz yok.',
      PERIOD_CLOSED: 'Dönem kapalı.',
      PERIOD_EXISTS: 'Bu dönem zaten açık.',
      FUTURE_PERIOD: 'Gelecek ay açılamaz.',
      DUPLICATE_LINE: 'Bu kişinin zaten satırı var.',
      CREW_NOT_ON_VESSEL: 'Kişi bu ay gemide değil (Crew List).',
      CURRENCY_MISMATCH: 'Para birimi kişinin hesap satırıyla aynı olmalı.',
      ENTRY_OUTSIDE_PERIOD: 'Tarih dönemin ayı içinde olmalı.',
      FUTURE_DATE: 'Tarih gelecekte olamaz.',
      PAYMENT_RECONCILED: 'Mutabık ödeme değiştirilemez.',
      REASON_REQUIRED: 'Gerekçe girin.',
      INVALID_CREDENTIALS: 'Parola yanlış.',
      NEGATIVE_NET: 'Bir kişinin kalanı eksi.',
      NO_LINES: 'Dönemde personel satırı yok.',
      ENTRY_WITHOUT_LINE: 'Bir kişinin girişleri var ama hesap satırı yok.',
      ROW_VERSION_CONFLICT: 'Kayıt başkası tarafından değiştirildi; yenileyip yeniden deneyin.',
      VALIDATION_FAILED: 'Alanları denetleyin.',
      OFFICE_IS_WRITER: 'Ödemeyi ofis girer.',
      PAYMENT_VOIDED: 'Ödeme kaldırılmış.',
      FILE_TYPE_MISMATCH: 'JPG, PNG ya da PDF dosyası ekleyin.',
      FILE_TOO_LARGE: 'Dosya 25 MB’tan büyük.',
      NO_PAYROLL_LINE: 'Önce kişinin hesap satırını ekleyin.',
      UNKNOWN_EXTRA_TYPE: 'Ekstra türü kaldırılmış; başka bir tür seçin.',
      DUPLICATE_EXTRA_TYPE: 'Bu adla bir tür zaten var.',
      INVALID_EXTRA_TYPE: 'Tür adı girin (en çok 100 karakter).',
      INVALID_PAYROLL_EXTRA: 'Ekstrayı denetleyin: tür, tutar ve “Diğer” için açıklama.',
      INVALID_PAYROLL_ENTRY:
        'Girişi denetleyin: tür, tarih, tutar ve “Diğer kesinti” ya da kayıp eşya için açıklama.',
      UNKNOWN_DEDUCTION_TYPE: 'Kesinti türü bu gemide bilinmiyor; başka bir tür seçin.',
      DEDUCTION_TYPE_INACTIVE: 'Kesinti türü pasifleştirildi; başka bir tür seçin.',
      DUPLICATE_DEDUCTION_TYPE: 'Bu adla bir kesinti türü zaten var.',
      INVALID_DEDUCTION_TYPE: 'Tür adı girin (en çok 100 karakter).',
    },
  },
  notices: {
    saved: 'Kaydedildi.',
    removed: 'Kaldırıldı.',
    reconciled: 'Ödeme mutabık.',
    closed: 'Dönem kapatıldı.',
    reopened: 'Dönem yeniden açıldı.',
    opened: 'Dönem açıldı.',
    uploaded: '{{name}} eklendi.',
  },
  pdf: {
    payslip: 'Ücret Pusulası',
    netList: 'Net Ödeme Listesi',
    vessel: 'Gemi',
    period: 'Dönem',
    crew: 'Personel',
    rank: 'Rütbe',
    currency: 'Para birimi',
    days: 'Gemide gün',
    earnings: 'Kazançlar',
    deductions: 'Kesintiler',
    wages: 'Maaş ({{wage}} üzerinden {{days}} gün)',
    extra: 'Ekstra',
    extraOvertime: 'Ekstra — fazla mesai',
    extraOvertimeHours: 'Ekstra — fazla mesai ({{hours}} sa × {{rate}})',
    extraOther: 'Ekstra — {{note}}',
    extraItem: 'Ekstra — {{label}}',
    homeAllotment: 'Home Allotment — {{name}}',
    cashAdvance: 'Gemide Avans',
    slopchest: 'Slopchest',
    otherDeductions: 'Diğer Kesinti',
    deductionItem: '{{label}} {{day}}',
    noDeductions: 'Kesinti yok',
    totalEarnings: 'Toplam kazanç',
    totalDeductions: 'Toplam kesinti',
    balance: 'Kalan',
    payments: 'Ödemeler',
    noPayments: 'Henüz kayıtlı ödeme yok.',
    date: 'Tarih',
    type: 'Tür',
    method: 'Yöntem',
    reference: 'Referans',
    amount: 'Tutar',
    statementNote:
      'Ödenecek ve ödenen ücretlerin aylık hesap dökümü (MLC 2006 Standart A2.2, paragraf 2). Tutarlar gemiadamının sözleşme para birimindedir; kur uygulanmadı.',
    seafarerSign: 'Gemiadamı imzası',
    masterSign: 'Kaptan imzası',
    closed: 'Dönem kapandı {{at}} · hash {{hash}}',
    open: 'Dönem açık — taslak',
    printed: 'Basım {{at}}',
    page: 'Sayfa {{page}} / {{pages}}',
    total: 'Toplam',
    people: '{{count}} kişi',
    netListNote:
      'Kalan = maaş + ekstra − Home Allotment − gemide avans − slopchest − diğer kesinti. Toplam ödenecek = kalan + Home Allotment. Toplamlar para birimine göre, kur çevirisi yok.',
  },
  csv: {
    name: 'Ad',
    rank: 'Rütbe',
    currency: 'Para birimi',
    wages: 'Maaş',
    extra: 'Ekstra',
    homeAllotment: 'Home Allotment',
    cashAdvance: 'Gemide Avans',
    slopchest: 'Slopchest',
    otherDeductions: 'Diğer Kesinti',
    balance: 'Kalan',
    payable: 'Toplam Ödenecek',
    total: 'Toplam',
  },
};
